import React, { Component } from "react";
import PropTypes from "prop-types";
import InputText from "../../molecules/form-input";
import { validarCampos } from "../../../utils/utils";

class GenericForm extends Component {
  constructor(props) {
    super(props);
    const { fields } = props;
    let data = {},
      labels = {},
      validations = {};
    fields.forEach((f) => {
      data[f.name] = "";
      labels[f.name] = f.label;
      validations[f.name] = f.validations;
    });
    this.state = {
      data: data,
      labels: labels,
      errors: {},
      validations: validations,
    };
  }

  componentDidMount() {
    if (this.props.initialValidation) {
      this.validarFormulario();
    }
  }

  handleChange = (e) => {
    const target = e.target;
    let data = { ...this.state.data };
    data[target.name] = target.value;

    this.setState({ data }, () => this.validarFormulario());
  };

  validarFormulario = () => {
    const { setValidForm, setFormData } = this.props;
    const { data, validations, labels } = this.state;
    let errors = { ...this.state.errors };
    errors = validarCampos(
      data,
      validations,
      errors,
      labels,
      Object.keys(data)
    );
    this.setState({ errors }, () => {
      setValidForm(Object.keys(errors).length === 0);
      setFormData(data);
    });
  };

  render() {
    const { fields, id } = this.props;
    const { data, labels, errors } = this.state;
    return fields.map((field, i) => (
      <InputText
        key={`${id}-field-${i}`}
        id={`${id}-field-${i}`}
        type={field.type}
        label={labels[field.name]}
        name={field.name}
        placeholder={field.placeholder}
        value={data[field.name]}
        error={errors[field.name]}
        onChange={this.handleChange}
        readOnly={field.readOnly}
      />
    ));
  }
}

GenericForm.propTypes = {
  id: PropTypes.string.isRequired,
  fields: PropTypes.arrayOf(PropTypes.object).isRequired,
  setFormData: PropTypes.func.isRequired,
  setValidForm: PropTypes.func.isRequired,
  initialValidation: PropTypes.bool,
};

GenericForm.defaultProps = {
  initialValidation: false,
  fields: [],
};

export default GenericForm;
